module.exports = __webpack_public_path__ + "img/100964.e7ddff3f.svg";